import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    sectionTitle: String
  }

  jump() {
    // Switch to AI Tutor tab via hash
    window.location.hash = "ai-tutor"

    // Find the tabs controller and trigger tab switch
    const tabsContainer = document.querySelector('[data-controller="tabs"]')
    if (tabsContainer) {
      const aiTutorTab = tabsContainer.querySelector('[data-tab-id="ai-tutor"]')
      if (aiTutorTab) {
        aiTutorTab.click()
      }
    }

    // Inject message into tutor input
    setTimeout(() => {
      const input = document.getElementById("tutor_message_input")
      if (input) {
        input.value = `Let's jump to section: ${this.sectionTitleValue}`
        input.focus()
        input.dispatchEvent(new Event("input", { bubbles: true }))
      }
    }, 100)
  }
}
